import { hideSpinner, showSpinner } from 'action/spinner'
import {
    ACCESS_ALLOWED,
    ACCESS_NOT_ALLOWED,
    CHANGE_TOTEM_TOKEN,
    FETCH_ROUTES_SUCCESS,
    LOGIN_FAILURE,
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGOUT,
} from 'actionTypes'
import API_URL from 'constants/api'
import { clearDatadogUser, setDatadogUser } from 'config/datadog'
import { push } from 'react-router-redux'
import ApiRequest from 'utils/ApiRequest'
import User from 'utils/User'
import { PING_URL_LOGOUT } from '../constants/api'
import { fetchMenus } from './menu'

const user = new User()
const requestLogin = () => ({ type: LOGIN_REQUEST })

export const fetchPingIdParameter = () => (dispatch) =>
  new ApiRequest(null, dispatch)
    .get(API_URL.PING_ID_PARAMETER)
    .then(dispatch(showSpinner()))
    .then(
      (response) =>
        response &&
        response.data &&
        response.data.resultList &&
        response.data.resultList[0] &&
        response.data.resultList[0].dsValue,
      (error) => error
    )
    .finally(() => dispatch(hideSpinner()))

const loginSuccess = (user) => ({
  type: LOGIN_SUCCESS,
  payload: user,
})

export const loginError = (data) => ({
  type: LOGIN_FAILURE,
  payload: data,
})

export const redirectToHome = (dispatch) => {
  dispatch(push('/'))
}

export const allowAccess = () => ({
  type: ACCESS_ALLOWED,
})

const notAllowAccess = () => ({
  type: ACCESS_NOT_ALLOWED,
})

export const loginUser =
  ({ dsLogin, dsPassword }) =>
  (dispatch) => {
    dispatch(requestLogin())

    const loginEncoded = encodeURIComponent(dsLogin)
    const passwordEncoded = encodeURIComponent(dsPassword)

    return new ApiRequest(null, dispatch)
      .post(API_URL.LOGIN, {
        dsLogin: loginEncoded,
        dsPassword: passwordEncoded,
      })
      .then(dispatch(showSpinner()))
      .then((response) => onFetchUserSuccess(response, dispatch))
      .catch((error) => onFetchUserError(error, dispatch))
  }

const fetchPermissionsError = (error, dispatch) => {
  dispatch(hideSpinner())
}

export const getUserInfo = (token, redirectToHome) => (dispatch) => {
  new ApiRequest(token, dispatch)
    .get(API_URL.GET_USER_INFO)
    .then(dispatch(showSpinner()))
    .then((response) => onFetchUserSuccess({
      ...response,
      data: {
        ...response.data,
        pingId: true
      }
    }, dispatch))
    .catch((error) => {
      onFetchUserError(error, dispatch) 
      if(redirectToHome) {
        redirectToHome()
      }
    })
}

const fetchPermissionsSuccess = (response, dispatch) => {
  dispatch({
    type: FETCH_ROUTES_SUCCESS,
    payload: response.data,
  })
  dispatch(hideSpinner())
}

export const fetchPermissions = (token) => (dispatch) =>
  new ApiRequest(token, dispatch)
    .get(API_URL.ROUTE_PERMISSIONS)
    .then(dispatch(showSpinner()))
    .then((response) => fetchPermissionsSuccess(response, dispatch))
    .catch((error) => fetchPermissionsError(error, dispatch))

  const onFetchUserSuccess = async (response, dispatch) => {
    const { data: isUserMatriz } = await new ApiRequest(response.data.dsToken, dispatch).get(API_URL.IS_USER_IN_HEADQUARTERS, {
    ldapNumber: response.data.username
  })
  
  const isLdapInManager = await new ApiRequest(response.data.dsToken, dispatch).get(API_URL.MANAGER_REPORT, {
    ldap: response.data.username
  })

  const reportLimitDaysFilter = await new ApiRequest(response.data.dsToken, dispatch).post(API_URL.PARAMETER_FIND, {
    dsKey: 'report.limit.days.filter',
    hasPagination: true,
    page: 1,
  })

    // Adding call to /accessLogin/save endpoint after successful login to save user data and information in the portal
   try {
   const accessLoginSave = await new ApiRequest(response.data.dsToken, dispatch).post(API_URL.ACCESS_LOGIN_SAVE, {
      cdLdap : response.data.username,
      idBranch: "",
      dtAccess: "", 
      versionCode:"00000001", 
      dsFriendlyName: "Browser Info",
      dsMacAddress:"Portal"
    });
     console.log("Resposta do servidor:", accessLoginSave)
  } catch (error) {
      console.error('Erro ao salvar informações de login:', error)
  }


  user.currentUser = {
    ...response.data,
    isUserMatriz,
    isLdapInManager: true,
    reportLimitDaysFilter: reportLimitDaysFilter &&
    reportLimitDaysFilter.data &&
    reportLimitDaysFilter.data.resultList &&
    reportLimitDaysFilter.data.resultList[0] &&
    reportLimitDaysFilter.data.resultList[0].dsValue,
    rangeLimitDays: 31,
    totemToken: ""
  
  }

  const params = {
    dsKey: "totem.user.access",
    nuParameter: 1
  }


 await new ApiRequest(response.data.dsToken, dispatch)
    .get(API_URL.PARAMETER_GET, params)
    .then(async resp => {
     try {

      const userPwd = resp.data.split(",")
      const store = userPwd[0]
      const pwd = userPwd[1]

      await new ApiRequest("", dispatch).post(API_URL.TOTEM_AUTH, {
        dsLogin: store,
        dsPassword: pwd
      })
      .then(res => {
        user.currentUser = {
          ...user.currentUser,
          totemToken: `Bearer ${  res.data.dsToken}`
        }
      })  
  
      .catch(err => {
        user.currentUser = {
          ...user.currentUser,
          totemToken: ""
        }
        console.error("Err  ->", err)})


     } catch(err) {

      console.error("Erro ->", err)
     }
      
    }).catch(err => console.error("Erro -> " , err))

  

 
  if(isLdapInManager && isLdapInManager.data && isLdapInManager.data.maxRangeDays) {
   
    user.currentUser = {
      ...user.currentUser,
      rangeLimitDays: isLdapInManager.data.maxRangeDays
    }
  } else if(isLdapInManager && isLdapInManager.data && !isLdapInManager.data.maxRangeDays) {
    user.currentUser = {
      ...user.currentUser,
      rangeLimitDays: null
    }
  } 
  

  dispatch(fetchMenus(user.currentUser))
  setDatadogUser(user.currentUser)
  dispatch(loginSuccess(user.currentUser))

  dispatch(hideSpinner())
  redirectToHome(dispatch)
  }

const onFetchUserError = (error, dispatch) => {
  user.clearCache()
  clearDatadogUser()
  dispatch(loginError(error))
  dispatch(hideSpinner())
}

export const refreshTotemToken = () => (dispatch, getState) => {
  const {
    auth: { user: currentUser },
  } = getState()

  return new ApiRequest(currentUser.dsToken, dispatch)
    .get(API_URL.PARAMETER_GET, { dsKey: 'totem.user.access', nuParameter: 1 })
    .then(async (resp) => {
      const [store, pwd] = resp.data.split(',')

      const res = await new ApiRequest('', dispatch).post(API_URL.TOTEM_AUTH, {
        dsLogin: store,
        dsPassword: pwd,
      })

      const newTotemToken = `Bearer ${res.data.dsToken}`

      dispatch({ type: CHANGE_TOTEM_TOKEN, payload: newTotemToken })

      user.currentUser = {
        ...user.currentUser,
        totemToken: newTotemToken,
      }

      return newTotemToken
    })
    .catch((error) => {
      console.error('Erro ao renovar token do totem:', error)
    })
}

/**
 * Wraps any action that calls the totem backend.
 * If the totem JWT is expired (401/403), automatically refreshes the totem token
 * and retries the original call once with the new token.
 *
 * @param {Function} actionFactory - receives the current totemToken and returns the Redux action to dispatch
 * @example
 *   dispatch(withTotemTokenRetry((totemToken) =>
 *     fetchTotemReportsFlux(user.dsToken, totemToken, data, signalController)
 *   ))
 */
export const withTotemTokenRetry = (actionFactory) => async (dispatch, getState) => {
  const getTotemToken = () => getState().auth.user?.totemToken

  try {
    return await dispatch(actionFactory(getTotemToken()))
  } catch (error) {
    const status = error?.cdStatus || error?.status
    if (status === 401 || status === 403) {
      const newTotemToken = await dispatch(refreshTotemToken())
      if (newTotemToken) {
        return dispatch(actionFactory(newTotemToken))
      }
      const refreshError = new Error('Falha ao renovar o token do totem: refreshTotemToken não retornou um token válido.')
      refreshError.isTotemRefreshFailure = true
      throw refreshError
    }
    throw error
  }
}

export const logout = () => {
  const doLogoutPingId = !!user.currentUser.pingId
  user.clearCache()
  clearDatadogUser()
  if (doLogoutPingId) window.location.replace(PING_URL_LOGOUT)
  return { type: LOGOUT }
}

export const checkPath = (route) => (dispatch, getState) => {
  // Removes the first url character ('/'),
  // then gets everything else until the next '/' through regex.
  // e.g: /schedules/1 returns schedules
  const path = route.substring(1, route.length).replace(/\/.*/, '')

  const {
    auth: { user },
  } = getState()

  const params = {
    naPrograma: path,
    cgBranch: user.locationCode,
  }

  return new ApiRequest(user.dsToken, dispatch)
    .post(API_URL.CHECK_PATH, params)
    .then(dispatch(showSpinner()))
    .then(() => {
      dispatch(allowAccess())
      dispatch(hideSpinner())
    })
    .catch(() => {
      dispatch(notAllowAccess())
      dispatch(push('/'))
      dispatch(hideSpinner())
    })
}
